export default "__VITE_ASSET__5bfd40a7__"